import React from 'react';

import ProductEditForm from '@components/shared/products/ProductEdit';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';

const AdminProductEdit: React.FC = () => {
  return (
    <ProductEditForm
      useProductService={useAdminProductService}
    />
  );
};

export default AdminProductEdit;
